import { Entity, Field } from 'typegraph';

@Entity({create: "createOrder"})
export class Order {

    @Field()
	entityId: number;
}


// WEBPACK FOOTER //
// ./src/panels/checkout/entities/Order.ts